/* eslint-disable @typescript-eslint/naming-convention */
export enum RequestsStatusEnum {
	Pending = 0,
	Success,
	Error
}
